exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput.form-control {\n&:disabled {\n        background: #f7f7f7;\n}\n}\n.order-select-container {\n    padding: 1em;\n    background-color: #F6BF40;\n    border: 1px solid ##F6BF40;\n    border-radius: 3px;\n}\n", ""]);

// exports
